// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Pw6","option":"styles_option__2C4rJ","selected":"styles_selected__1qFZ4"};